<template>
  <v-app>
    <v-container fluid>
      <v-card variant="outlined">
        <v-card-title class="d-flex flex-wrap align-center ga-2 bg-blue-grey-lighten-4 text-subtitle-1">
          <span>Finished-Goods Inventory Receipt List</span>
          <v-spacer />
          <v-text-field v-model="search" label="Search" prepend-inner-icon="mdi-magnify" density="compact" variant="outlined" hide-details clearable style="max-width: 280px" />
          <v-btn color="primary" prepend-icon="mdi-plus" :to="{ name: 'production-receive' }">Receive Finished Goods</v-btn>
        </v-card-title>
        <v-data-table :headers="headers" :items="items" :search="search" :loading="loading" density="compact">
          <template #item.index="{ index }">{{ index + 1 }}</template>
          <template #item.delivery="{ item }">{{ item.production_delivery?.code || '-' }}</template>
          <template #item.warehouse="{ item }">{{ item.warehouse?.name || '-' }}</template>
          <template #item.items="{ item }">
            <div v-for="detail in item.details || []" :key="detail.id" class="text-caption">
              {{ detail.product?.name }} · {{ detail.lot_no || detail.batch_no || '-' }} · {{ number(detail.qty) }}
            </div>
          </template>
          <template #item.amount="{ item }">{{ number(item.amount, 2) }}</template>
          <template #item.approval_status="{ item }">
            <v-chip size="small" :color="approvalColor(item.approval_status)">{{ item.approval_status || (item.status ? 'Pending' : 'Draft') }}</v-chip>
          </template>
          <template #item.actions="{ item }">
            <v-btn icon="mdi-file-document-outline" color="blue" variant="text" size="small" :to="{ name: 'production-receive-details', params: { id: item.id } }" />
            <v-btn v-if="canEdit(item) && $updateAccess($route.path)" icon="mdi-pencil-outline" color="primary" variant="text" size="small" :to="{ name: 'production-receive', params: { id: item.id } }" />
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-app>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { toast } from "vue3-toastify";

const store = useStore();
const search = ref("");
const loading = ref(false);
const items = computed(() => store.getters.getInvProductionReceiveList || []);
const headers = [
  { title: "#", key: "index", sortable: false },
  { title: "Receipt", key: "code" },
  { title: "Production Delivery", key: "delivery" },
  { title: "Receive Date", key: "receive_date" },
  { title: "Warehouse", key: "warehouse" },
  { title: "Products / Lot / Qty", key: "items", sortable: false },
  { title: "Amount", key: "amount", align: "end" },
  { title: "Approval", key: "approval_status" },
  { title: "Actions", key: "actions", sortable: false },
];

function number(value, digits = 4) {
  return Number(value || 0).toLocaleString(undefined, { maximumFractionDigits: digits });
}

function approvalColor(status) {
  if (status === "Approved") return "success";
  if (status === "Cancelled" || status === "Rejected") return "error";
  return "warning";
}

function canEdit(item) {
  return !item.posted_at && !item.approval_current_process && (!item.approval_status || item.approval_status === "Pending") && Number(item.status) === 0;
}

onMounted(async () => {
  loading.value = true;
  try {
    await store.dispatch("getInvProductionReceiveList");
  } catch (error) {
    toast.error(error?.response?.data?.message || "Finished-goods receipt list could not be loaded.");
  } finally {
    loading.value = false;
  }
});
</script>
